import {FC} from 'react'
import {ProductThumb} from '../../../components/common/ProductThumb'
import {useIntl} from 'react-intl'
import {Link} from 'react-router-dom'
import {IReportSalesModel} from '../core/_models'
import {storeCurrencyLabel} from '../../common/currencyLabel'

type IProps = {
    item: IReportSalesModel,
    showDetails: (params?: IReportSalesModel) => void
}
const SalesReportTableRow: FC<IProps> = ({item, showDetails}) => {
    const {formatMessage} = useIntl()

    return (
        <tr>
            <th>
                <ProductThumb src={item.image} className='table-img' alt='Product'/>
            </th>
            {/* Multi-supplier (T4): jump from a sales row to the supplier's
                own offer for that product (barcode search). */}
            <td>
                {item.barcode ? (
                    <Link to={`/offers/list?search=${encodeURIComponent(item.barcode)}`} title={formatMessage({id: 'reports.view_my_offer'})}>
                        {item.barcode}
                    </Link>
                ) : '—'}
            </td>
            <td>{item.model}</td>
            <td>{item.name}</td>
            <td>{item.adjusted_quantity}</td>
            <td style={{color: 'green'}}>{item.average_sale_price}{storeCurrencyLabel(formatMessage)}</td>
            <td style={{color: 'green'}}>{item.total_sale_price}{storeCurrencyLabel(formatMessage)}</td>
            <td style={{color: 'green'}}>{item.dumyah_fees}{storeCurrencyLabel(formatMessage)}</td>
            <td style={{color: 'green'}}>{item.net}{storeCurrencyLabel(formatMessage)}</td>

        </tr>
    )
}

export default SalesReportTableRow
